(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrslm-faq-page"]) return;
  try {
    
document.querySelectorAll('[data-mf-faq]').forEach(root => {
  const search = root.querySelector('[data-mf-faq-search]');
  search.addEventListener('input', () => {
    const query = search.value.trim().toLowerCase();
    let total = 0;
    root.querySelectorAll('[data-mf-faq-group]').forEach(group => {
      let count = 0;
      group.querySelectorAll('[data-mf-faq-item]').forEach(item => {
        const match = item.textContent.toLowerCase().includes(query);
        item.hidden = !match;
        if (match) count++;
      });
      group.hidden = count === 0;
      total += count;
    });
    root.querySelector('[data-mf-faq-empty]').hidden = total > 0;
  });
});

  } catch(e) { console.error(e); }
})();
})();
